<template>
  <div class="modal custom-fade fade" id="add_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div class="form-header modal-header-title text-start mb-0">
            <h4 class="mb-0">Add Expenses</h4>
          </div>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span class="align-center" aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="addExpenses">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Customer</label>
                  <SelectMenu
                        v-model="selectedCustomer"
                        :options="customers"
                        label="Customer"
                        optionAttribute="name"
                        placeholder="Search Customer"
                        searchAttribute="name"
                      />
                </div>
                <div class="row">
                  <div class="form-group col-lg-6 col-md-6 col-sm-12">
                    <label>Currency</label>
                    <select
                      v-model="form.currency"
                      class="form-select"
                      required
                    >
                      <option value="NGN : Naira" selected required>
                        NGN : Naira
                      </option>
                      <option
                        v-for="(currency, index) in allCurrencyCodes"
                        :key="index"
                        :value="currency"
                      >
                        {{ currency }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Amount </label>
                      <input
                        type="number"
                        v-model="form.amount"
                        class="form-control"
                        placeholder="Enter Amount"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Expense Date </label>
                      <datepicker
                        v-model="currentDate"
                        class="picker"
                        :editable="true"
                        :clearable="false"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-upload-label">
                      <label class="mb-0"
                        >Attachment<span class="text-muted"
                          >(Optional)</span
                        ></label
                      >
                    </div>
                    <div class="form-upload-file" style="overflow: hidden">
                      <span
                        ><i class="feather feather-upload-cloud me-2"></i
                        >{{ imageName ? imageName : "Attach File" }}</span
                      >
                      <input
                        type="file"
                        @change="onChangeFile"
                        id="image_sign"
                      />
                      <div id="frames"></div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Notes</label>
                    <textarea
                      type="text"
                      v-model="form.notes"
                      class="form-control"
                      placeholder="Enter Notes"
                    ></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label
                        >Mark as recurring
                        <span class="text-muted">(Optional)</span></label
                      >
                      <div class="status-toggle mt-4" style="margin-left: 20px">
                        <div class="d-flex">
                          <input
                            id="rating_1"
                            class="check"
                            true-value="1"
                            false-value="0"
                            v-model="form.recurring"
                            type="checkbox"
                          />
                          <label for="rating_1" class="checktoggle checkbox-bg"
                            >checkbox</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="form.recurring === '1'">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Recurring Duration Mode</label>
                      <select
                        class="form-select"
                        v-model="form.recurring_duration.mode"
                      >
                        <option :value="null" selected>Select Mode</option>
                        <option value="day">Daily</option>
                        <option value="week">Weekly</option>
                        <option value="month">Monthly</option>
                        <option value="year">Annually</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Recurring Duration Value </label>
                      <input
                        type="number"
                        v-model="form.recurring_duration.value"
                        class="form-control"
                        placeholder="Enter Duration Value"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button aria-label="Close" type="button" data-bs-dismiss="modal" class="btn btn-primary cancel me-2">
              Cancel
            </button>
            <button type="submit" :disabled="isLoading" class="btn btn-primary">
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-if="!isLoading">Add Expense</span>
              <span v-if="isLoading">Saving...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, onMounted, watch, defineEmits } from "vue";
import { useStore } from "vuex";
import { formatDateToDashDigits } from "@/assets/composables/date";
import { createToaster } from "@meforma/vue-toaster";
import SelectMenu from "../../../components/selectMenu.vue";
const selectedCustomer = ref(null);
const toast = createToaster({ position: "top-right", duration: 3000 });
const currencyCodes = require("currency-codes");

// Get all currency codes
const allCurrencyCodes = computed(() => {
  return currencyCodes.data.map(
    (currency) => `${currency.code} : ${currency.currency}`
  );
});

const emit = defineEmits(["closeAddModal"]);

const store = useStore();
const currentDate = ref(new Date());
const isLoading = ref(false);

const emptyForm = () => ({
  customer_id: "",
  date: "",
  amount: "",
  notes: "",
  currency: "NGN : Naira",
  recurring: "0",
  recurring_duration: {
    mode: null,
    value: null,
  },
  attachment: "",
});

const form = ref(emptyForm());

watch(
  currentDate,
  (newValue) => {
    form.value.date = formatDateToDashDigits(newValue);
  },
  { immediate: true }
);
watch(selectedCustomer, (newVal) => {
  form.value.customer_id =  newVal.id
});

const imageName = ref("");

const onChangeFile = (event) => {
  imageName.value = event.target.files[0].name;
  form.value.attachment = event.target.files[0];
};

const customers = computed(() => {
  return store.getters["customer/customers"].data;
});

const getCustomers = () => {
  let data = {
    page: 1,
    per_page: 1000,
    query: "",
  };
  store.dispatch("customer/getCustomers", data);
};

const addExpenses = () => {
  if ( form.value.recurring === "1" &&
  (!form.value.recurring_duration.mode || !form.value.recurring_duration.value)){
     toast.error("Reoccurring is active: Please enter a reoccurring duration");
  }
  else {
    isLoading.value = true;
    store
      .dispatch("expenses/addExpenses", form.value)
      .then(() => {
        isLoading.value = false;
        emit("closeAddModal");
        form.value = emptyForm();
        imageName.value = "";
      })
      .catch(() => {
        isLoading.value = false;
      });
  }
};

onMounted(() => {
  getCustomers();
});
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
